import React from 'react';
import { motion } from 'framer-motion';

export function PrivacyPolicyPage() {
  return (
    <div className="pt-32 pb-16 px-4">
      <motion.div 
        className="max-w-4xl mx-auto prose prose-lg"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last Updated: October 6 2024</p>
        
        <p className="mb-6">
          This privacy notice for Convertology.ai ("Company," "we," "us," or "our") describes how and why we may collect, store, use, and/or share ("process") your information when you use our Services.
        </p>

        <div className="bg-gray-50 p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-bold mb-4">Summary of Key Points</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>We collect personal information that you voluntarily provide to us</li>
            <li>We do not process sensitive personal information</li>
            <li>We do not receive any information from third parties</li>
            <li>We use industry-standard security measures to protect your data</li>
            <li>You have certain rights regarding your personal information</li>
          </ul>
        </div>

        <h2 className="text-2xl font-bold mt-12 mb-4">1. What Information Do We Collect?</h2>
        <p>We collect personal information that you voluntarily provide when you:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Register on the Services</li>
          <li>Express interest in our products and Services</li>
          <li>Provide website URLs for analysis</li>
          <li>Contact us directly</li>
        </ul>

        <h2 className="text-2xl font-bold mt-12 mb-4">2. How Do We Process Your Information?</h2>
        <p>We process your information to:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Provide website analysis services</li>
          <li>Manage user accounts</li>
          <li>Respond to inquiries and support requests</li>
          <li>Process payments and fulfill orders</li>
        </ul>

        <h2 className="text-2xl font-bold mt-12 mb-4">3. Your Privacy Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul className="list-disc pl-6 mb-6">
          <li>Access your personal information</li>
          <li>Request correction or deletion</li>
          <li>Restrict processing</li>
          <li>Object to processing</li>
        </ul>

        <h2 className="text-2xl font-bold mt-12 mb-4">4. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <p className="mt-2">
          <a href="mailto:info@convertology.ai" className="text-green-500 hover:text-green-600">
            info@convertology.ai
          </a>
        </p>
      </motion.div>
    </div>
  );
}